import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { ButtonV2 } from '@zola/zola-ui';
import { trackRecommendation } from '../../../../../util/trackingHelper';

const AddButtons = ({ onAdd }) => {
  // marketing & tracking
  const [hasTrackedCTAViewed, setHasTrackedCTAViewed] = useState(false);
  const onCTAClick = () => {
    trackRecommendation('Viewed', {
      recommedation_key: 'hotelplanner_cms_travel',
      recommedation_name: 'Hotel Planner CMS Travel',
      recommondation_copy: 'Book Hotel Blocks',
      location: 'Manage Travel Page',
      section: 'Header Section',
    });
  };
  useEffect(() => {
    if (!hasTrackedCTAViewed) {
      setHasTrackedCTAViewed(true);
      trackRecommendation('Viewed', {
        recommendation_key: 'hotelplanner_cms_travel',
        recommondation_name: 'Hotel Planner CMS Travel',
        recommendation_copy: 'Book Hotel Blocks',
        location: 'Manage Travel Page',
        section: 'Header Section',
      });
    }
  }, []);
  return (
    <>
      <ButtonV2 type="button" onClick={onAdd}>
        Add Travel & Places To Stay
      </ButtonV2>
      <ButtonV2
        onClick={onCTAClick}
        className="edit-page__affiliate-link"
        variant="secondary"
        role="link"
        target="_blank"
        rel="noopener noreferrer"
        component="a"
        href="http://zola.hotelplanner.com/?kw=websitetravelcms"
      >
        Book Hotel Blocks
      </ButtonV2>
    </>
  );
};

AddButtons.propTypes = {
  onAdd: PropTypes.func,
};

export default AddButtons;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/Travel/AddButtons.jsx